import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28e9c493"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-id": "resume",
  class: "resume-section"
}
const _hoisted_2 = { class: "section-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Resume")
], -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-xs-12 col-sm-7" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "white-space-50" }, null, -1))
const _hoisted_7 = { class: "col-xs-12 col-sm-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("Analysis & Design "),
    /*#__PURE__*/_createElementVNode("span", null, "Skills")
  ])
], -1))
const _hoisted_9 = { class: "skills-info skills-second-style" }
const _hoisted_10 = { class: "skill clearfix" }
const _hoisted_11 = { class: "skill-value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skill-container skill-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "skill-percentage" })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "white-space-10" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("Coding "),
    /*#__PURE__*/_createElementVNode("span", null, "Skills")
  ])
], -1))
const _hoisted_15 = { class: "skills-info skills-second-style" }
const _hoisted_16 = { class: "skill clearfix" }
const _hoisted_17 = { class: "skill-value" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skill-container skill-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "skill-percentage" })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "white-space-10" }, null, -1))
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"white-space-50\" data-v-28e9c493></div><div class=\"row\" data-v-28e9c493><div class=\"col-xs-12 col-sm-12\" data-v-28e9c493><div class=\"block-title\" data-v-28e9c493><h3 data-v-28e9c493>Certificates</h3></div></div></div><div class=\"row\" data-v-28e9c493><div class=\"col-xs-12 col-sm-6\" data-v-28e9c493><div class=\"certificate-item clearfix\" data-v-28e9c493><div class=\"certi-logo\" data-v-28e9c493><img src=\"img/certs/ICA-logo-full-TM-500px.png\" alt=\"logo\" data-v-28e9c493></div><div class=\"certi-content\" data-v-28e9c493><div class=\"certi-title\" data-v-28e9c493><h4 data-v-28e9c493>Certified Professional in Test Automation (ICP-ATA)</h4></div><div class=\"certi-id\" data-v-28e9c493><span data-v-28e9c493>Wellington, New Zealand</span></div><div class=\"certi-date\" data-v-28e9c493><span data-v-28e9c493>April 2018</span></div><div class=\"certi-company\" data-v-28e9c493><span data-v-28e9c493></span></div></div></div></div><div class=\"col-xs-12 col-sm-6\" data-v-28e9c493><div class=\"certificate-item clearfix\" data-v-28e9c493><div class=\"certi-logo\" data-v-28e9c493><img src=\"/img/certs/cisco.png\" alt=\"logo\" data-v-28e9c493></div><div class=\"certi-content\" data-v-28e9c493><div class=\"certi-title\" data-v-28e9c493><h4 data-v-28e9c493>Cisco Certified Network Associate (CCNA) I, II, III, IV</h4></div><div class=\"certi-id\" data-v-28e9c493><span data-v-28e9c493>Wellington, NZ</span></div><div class=\"certi-date\" data-v-28e9c493><span data-v-28e9c493>April 2013 - November 2016</span></div><div class=\"certi-company\" data-v-28e9c493><span data-v-28e9c493></span></div></div></div></div></div>", 3)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Education = _resolveComponent("Education")!
  const _component_Experience = _resolveComponent("Experience")!
  const _component_Knowledges = _resolveComponent("Knowledges")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Education, { education: _ctx.education }, null, 8, ["education"]),
          _hoisted_6,
          _createVNode(_component_Experience, { experience: _ctx.experience }, null, 8, ["experience"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.designSkills, (dskill, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h4", null, _toDisplayString(dskill.skill), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(dskill.level), 1)
                ]),
                _hoisted_12
              ]))
            }), 128))
          ]),
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codingSkills, (cskill, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("h4", null, _toDisplayString(cskill.skill), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(cskill.level), 1)
                ]),
                _hoisted_18
              ]))
            }), 128))
          ]),
          _hoisted_19,
          _createVNode(_component_Knowledges, { knowledges: _ctx.knowledges }, null, 8, ["knowledges"])
        ])
      ]),
      _hoisted_20
    ])
  ]))
}